export default __webpack_public_path__ + "static/media/BlueStars5.6b82b199.svg";